import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';

import {initialize, login, updatePassword} from '../../modules/auth';

import Login from '../../components/login/Login';
import PasswordChange from '../../components/login/PasswordChange';

const wrapperStyle = {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#F6F6FF'
};

export default function LoginContainer() {
    const dispatch = useDispatch();

    const location = useLocation();

    const { auth, authError, authLoading, updateResponse, updateError, updateLoading  } = useSelector(({ auth, loading }) => ({
        auth: auth.auth,
        authError: auth.authError,
        authLoading: loading['auth/LOGIN'],
        updateResponse: auth.updateResponse,
        updateError: auth.updateError,
        updateLoading: loading['auth/UPDATE_PASSWORD']
    }));
    
    const handleSubmit = (loginForm) => {
        const { userId, password } = loginForm;
        dispatch(login({ userId, password }));
    };

    const handleModify = (passwordForm) => {
        const { userId, password, newPassword } = passwordForm;
        dispatch(updatePassword({ userId, password, newPassword }));
    };

    const handleInitialize = () => {
        dispatch(initialize());
    };

    useEffect(() => {
        handleInitialize();
    }, []);

    return (
        <div style={wrapperStyle}>
            {location.pathname === '/auth/login' && 
                <Login
                    response={auth}
                    error={authError}
                    loading={authLoading}
                    handleSubmit={handleSubmit}
                />
            }
            {location.pathname === '/auth/password' &&
                <PasswordChange
                    response={updateResponse}
                    error={updateError}
                    loading={updateLoading}
                    handleModify={handleModify}
                    handleInitialize={handleInitialize}
                />
            }
        </div>
    );
}
